import { createContext, useEffect, useReducer } from 'react';
import { useGetCreditsAvailable } from '../hooks/useCreditContext';
import useAuthContext from '../hooks/useAuthContext';
import { message } from 'antd';
const CreditContext = createContext();

const actionReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CREDITS':
      return {
        ...state,
        credits: action.payload,
      };
    default:
      return state;
  }
};

const CreditContextProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuthContext();
  const [creditsAvailable, dispatcher] = useReducer(actionReducer, {
    credits: {},
  });

  function onSuccess(data) {
    if (data?.data?.data?.creditsAvailable) {
      dispatcher({
        type: 'SET_CREDITS',
        payload: data?.data?.data?.creditsAvailable,
        // payload: 0,
      });
    }
  }

  function onError(error) {
    console.log(error);
  }

  const { refetch: refetchCredits } = useGetCreditsAvailable(
    isAuthenticated,
    user?.userToken,
    onSuccess,
    onError
  );

  return (
    <CreditContext.Provider
      value={{
        ...creditsAvailable,
        creditsDispatcher: dispatcher,
        refetchCredits,
      }}
    >
      {children}
    </CreditContext.Provider>
  );
};
export { CreditContext, CreditContextProvider };
